import { IGetJobPostingsPayload, IGetJobPostingsResult } from '../types';
import { PermanentJobsApi } from '../clients';
import { JobPostAdapters } from '../adapters';

export const getJobPostings = async (
  payload: IGetJobPostingsPayload,
): Promise<IGetJobPostingsResult> => {
  const response = await PermanentJobsApi.getJobPostings(payload);

  return JobPostAdapters.toGetJobPostingsResult(response);
};
